// Calendly event names to window.postMessage()

// Event type page was viewed
export const calendlyPageView = 'calendly.event_type_viewed';

// Invitee selected date and time
export const calendlyConfirmBooking = 'calendly.date_and_time_selected';

// Invitee successfully booked a meeting
export const calendlyScheduleEvent = 'calendly.event_scheduled';
